import { useMutation, useQueryClient } from '@tanstack/react-query';

import { apiClient } from '@/lib/api/client';
import { useTenantStore } from '@/stores/tenantStore';

import type { RoleFormInput } from '../schemas/roleSchemas';
import { roleKeys } from './roleKeys';

interface UpdateRoleInput extends RoleFormInput {
  roleId: string;
}

export function useUpdateRole() {
  const qc = useQueryClient();
  const tenantId = useTenantStore((s) => s.tenantId);

  return useMutation({
    mutationFn: ({ roleId, ...body }: UpdateRoleInput) =>
      apiClient.put(`api/v1/t/${tenantId}/roles/${roleId}`, { json: body }).json(),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: roleKeys.lists() });
      qc.invalidateQueries({ queryKey: ['roles', 'list', tenantId] });
    },
  });
}
